export * from './addressSuggestions.service';
import { AddressSuggestionsService } from './addressSuggestions.service';
export * from './basicInsurances.service';
import { BasicInsurancesService } from './basicInsurances.service';
export * from './counselings.service';
import { CounselingsService } from './counselings.service';
export * from './cspReport.service';
import { CspReportService } from './cspReport.service';
export * from './environment.service';
import { EnvironmentService } from './environment.service';
export * from './errors.service';
import { ErrorsService } from './errors.service';
export * from './features.service';
import { FeaturesService } from './features.service';
export * from './frameworkContracts.service';
import { FrameworkContractsService } from './frameworkContracts.service';
export * from './medicalOffices.service';
import { MedicalOfficesService } from './medicalOffices.service';
export * from './medicalOfficesByNameOrZipCode.service';
import { MedicalOfficesByNameOrZipCodeService } from './medicalOfficesByNameOrZipCode.service';
export * from './medicalOfficesForInsuranceModelType.service';
import { MedicalOfficesForInsuranceModelTypeService } from './medicalOfficesForInsuranceModelType.service';
export * from './offers.service';
import { OffersService } from './offers.service';
export * from './orderOffers.service';
import { OrderOffersService } from './orderOffers.service';
export * from './premiumYear.service';
import { PremiumYearService } from './premiumYear.service';
export * from './requestHelp.service';
import { RequestHelpService } from './requestHelp.service';
export * from './saleOfferBegins.service';
import { SaleOfferBeginsService } from './saleOfferBegins.service';
export * from './submissions.service';
import { SubmissionsService } from './submissions.service';
export * from './supplementaryInsurances.service';
import { SupplementaryInsurancesService } from './supplementaryInsurances.service';
export const APIS = [AddressSuggestionsService, BasicInsurancesService, CounselingsService, CspReportService, EnvironmentService, ErrorsService, FeaturesService, FrameworkContractsService, MedicalOfficesService, MedicalOfficesByNameOrZipCodeService, MedicalOfficesForInsuranceModelTypeService, OffersService, OrderOffersService, PremiumYearService, RequestHelpService, SaleOfferBeginsService, SubmissionsService, SupplementaryInsurancesService];
